class Cookies {
    constructor() {
        if (!Cookies.hasCookiesAcceptation()) {
            this.initComponent();
        }
    }

    static hasCookiesAcceptation() {
        return window.localStorage.getItem('cookiesAcceptation');
    }

    static createEntity() {
        window.localStorage.setItem('cookiesAcceptation', 'true');
    }

    initComponent() {
        this.buildTemplate();
        this.attachEvents();
    }

    buildTemplate() {
        this.element = document.createElement('div');
        this.element.classList.add('cookies');
        this.element.innerHTML = `
        <div class="container cookies__container">
            <div class="cookies__inner">
                <div class="cookies__text">Cайт MostMe.ru использует файлы cookie и другие технологии для вашего удобства пользования сайтом, анализа использования наших товаров и услуг и повышения качества рекомендаций.</div>
                <button class="button button--border button--white cookies__button jsCookiesButton" type="button">
                    <span>Хорошо</span>
                </button>
            </div>
        </div>
        `;
        
        document.body.append(this.element);

        setTimeout(() => {
            document.querySelector('.cookies').classList.add('is-show');
        }, 2000);
    }

    attachEvents() {
        document.querySelector('.jsCookiesButton').addEventListener('click', (e) => {
            Cookies.createEntity();
            document.querySelector('.cookies').classList.remove('is-show');

            setTimeout(() => {
            this.element.remove();
            }, 750);
        });
    }
}

export default Cookies;
